import { globalSort } from './../../shared/libraries/sort'
import { SORT_DIRECTION } from '../TableTable/types'

export const filterTableDataLogic = ({
  data,
  searchOn,
  selectedFilters,
  searchText,
}) => {
  return data.filter(dto => {
    // Filter by search text first
    if (searchText) {
      var match = searchOn.some(key => {
        var subject = (dto[key] || '').toString().toLowerCase()
        var pattern = new RegExp(searchText, 'gi')
        return subject.match(pattern)
      })
      if (!match) return false
    }
    // Filter by the selected filter options
    return Object.keys(selectedFilters)
      .filter(key => selectedFilters[key])
      .every(key => dto[key] == selectedFilters[key])
  })
}

export const sortTableDataLogic = ({ data, sortOn, sortBy }) => {
  if (!sortBy) return data

  const orderKey = sortBy.column

  // See if there's a custom sort
  const sortOnOption = sortOn.find(
    s =>
      typeof s === 'object' &&
      typeof s.sort === 'function' &&
      s.label == orderKey,
  )

  if (sortOnOption) {
    const orderedData = Array.from(data)
    orderedData.sort((a, b) => sortOnOption.sort(a[orderKey], b[orderKey]))
    if (sortBy.direction === SORT_DIRECTION.DECENDING) orderedData.reverse()
    return orderedData
  } else {
    return globalSort({
      data,
      sortingKey: orderKey,
      ASC: sortBy.direction === SORT_DIRECTION.ASCENDING,
    })
  }
}

export const getForceRerenderSpookyFlag = data => {
  // To prevent:
  // "Failed to execute 'btoa' on 'Window':
  // The string to be encoded contains characters
  // outside of the Latin1 range."
  // https://stackoverflow.com/questions/23223718/failed-to-execute-btoa-on-window-the-string-to-be-encoded-contains-characte
  return btoa(unescape(encodeURIComponent(JSON.stringify(data))))
}



// WEBPACK FOOTER //
// ./src/Components/SimpleTableTable/util.js